import { CircleHelp } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';

interface FieldHelpTooltipProps {
  content: string;
  'data-testid'?: string;
}

/**
 * A question-mark icon next to a field label that reveals `content` in a tooltip
 * on hover/focus, keeping secondary guidance off the form while discoverable.
 */
export const FieldHelpTooltip = ({ content, ...props }: FieldHelpTooltipProps) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={content}
          className="inline-flex text-foreground-subtle transition-colors hover:text-foreground"
          data-testid={props['data-testid']}
        >
          <CircleHelp className="size-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent>{content}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default FieldHelpTooltip;
